import { Component, h, Listen } from '@stencil/core';
import { QueryParamsHelpers } from '../../../../../shared/helpers/query-params.helpers';
import { SidebarFormTypes } from './sidebar-form/sidebar-form-types.enum';
import { get as getState, set as setState } from './sidebar-form/sidebar-form.store';
import { sdkLogHelper } from '../../../../../shared/helpers/sdk-log.helper';
import { TrackerEventsEnum } from '../../../../../shared/models/tracker-events.enum';
import get from 'lodash/get';

@Component({
  tag: 'login-sidebar',
  styleUrl: 'login-sidebar.scss',
})
export class LoginSidebar {
  sidebarId: string = 'loginSidebar';

  componentDidLoad() {
    this.handleQueryParams();
    setState('currentForm', SidebarFormTypes.otp)
  }

  translate = (key) => {
    return get(window['loginSidebar'], key, key);
  }

  @Listen('openLoginSidebar', { target: 'document' })
  openHandler() {
    this.open();
  }
  @Listen('onCloseSidebarRight', { target: 'document' })
  closeSidebar() {
    this.resetSidebarForms();
  }

  get isNLStore(): boolean {
    return window['apomedsConfigs']?.region === 'nl';
  }

  setActiveTab(tab:SidebarFormTypes) {
    sdkLogHelper(
      tab === SidebarFormTypes.login ? TrackerEventsEnum.otpPasswordTabLoginClicked : TrackerEventsEnum.otpPasswordTabOtpClicked,
      { query_params: window.location.search }
    );

    setState('currentForm', tab);
  }

  isActiveTav(tab:SidebarFormTypes) {
    setState('loginErrors', null);
    return getState('currentForm') === tab;
  }

  private resetSidebarForms() {
    document.dispatchEvent(new CustomEvent('resetState', {
      detail: {
        formId: 'sidebarForm',
      },
    }));
  }

  private open() {
    document.dispatchEvent(new CustomEvent('openSidebar', {
      detail: {
        sidebarId: this.sidebarId,
      },
    }));
  }

  private handleQueryParams() {
    const queryParams = QueryParamsHelpers.queryParams;
    if (queryParams.openLoginSidebar) {
      this.open();
      let url = window.location.origin + window.location.pathname;
      delete queryParams.openLoginSidebar;
      let search = QueryParamsHelpers.queryParamsToString(queryParams);
      window.history.replaceState({}, document.title, url + search);
    }
  }

  render() {
    return <sidebar-right sidebar-id={this.sidebarId}>
      <div class="popup-login">
        <div class="popup-login__content">
          {
            getState('currentForm') !== SidebarFormTypes.resetPassword && !this.isNLStore ?
              <nav class="popup-login__content--otp-password_tab">
                <ul>
                  <li class={this.isActiveTav(SidebarFormTypes.login) ? 'active' : ''}
                      onClick={() => this.setActiveTab(SidebarFormTypes.login)}>{this.translate('PasswordTab')}
                  </li>
                  <li class={this.isActiveTav(SidebarFormTypes.otp) ? 'active' : ''}
                      onClick={() => this.setActiveTab(SidebarFormTypes.otp)}>{this.translate('OTPTab')}
                  </li>
                </ul>
              </nav>
              :
              ''
          }
          <div class="popup-login-main">
            <sidebar-form/>
          </div>
        </div>
        <div class="popup-login-bottom">
          <h4 class="popup-login-bottom-title">{this.translate('ContactUs')}</h4>
          <div class="popup-login-contacts">
            <contact-livechat type="login-popup" />
            {/* Temporary disabled due to AS-10079. Not fully removed because it will be enabled again in near future */}
            {/* { this.isDeStore && <whatsapp-link type="name"/> } */}
            <slot name="contact-phone" />
            <slot name="contact-email" />
          </div>
        </div>
      </div>
    </sidebar-right>
  }
}
